import React from 'react';
import { Link } from 'react-router-dom';

export default () => (
  <div>
    404 页面没有找到... | <Link to="/">返回主页</Link>
  </div>
);
